import React from 'react';
import PropTypes from 'prop-types';
import { connect, getIn } from 'formik';

import { withStyles } from '~/assets/withStyles';
import ToggleButtonGroup from '~/components/core/Molecules/Fields/ToggleButtonGroup';

import { ErrorHelperTextFormik } from './core/Formik/ErrorHelperTextFormik';

const styles = (theme) => ({
  toggleContainer: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: `${theme.spacing(1)} 0`,
  },
});

const ToggleButtonGroupFormik = withStyles(
  connect((props) => {
    const { classes, formik, id, children, showOnly, options, onChange } = props;
    const { values, setFieldValue } = formik;

    if (showOnly) {
      const currValue = getIn(values, id);
      let node;
      React.Children.forEach(children, (toggleButton) => {
        if (toggleButton.props.value === currValue) {
          node = toggleButton.props.children;
        }
      });
      return node;
    }

    const handleChange = (event, value) => {
      setFieldValue(id, value);
      if (onChange) {
        onChange(value);
      }
    };

    return (
      <>
        <div className={classes.toggleContainer}>
          <ToggleButtonGroup value={getIn(values, id)} exclusive onChange={handleChange} options={options} />
        </div>
        <ErrorHelperTextFormik id={id} />
      </>
    );
  }),
  styles
);

ToggleButtonGroupFormik.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  showOnly: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default ToggleButtonGroupFormik;
